// extracted by mini-css-extract-plugin
export var root = "index-module--root--+na8q";
export var tagline = "index-module--tagline--oyA2E";